import { render, staticRenderFns } from "./ListGroups.vue?vue&type=template&id=566c94a4"
import script from "./ListGroups.vue?vue&type=script&lang=js"
export * from "./ListGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports